import { t } from '../../../../../common/i18n.js'
import type { Language } from '../../../../../common/types/i18n.js'
import { Button } from '../../../../components/button/button.js'

interface Props {
    lang: Language
    editMode: boolean
    isDirty: boolean
    isMobile: boolean
    onStart: () => void
    onSave: () => void
    onCancel: () => void
    saveError?: string | null
}

export const EditModeToolbar = ({
    lang,
    editMode,
    isDirty,
    isMobile,
    onStart,
    onSave,
    onCancel,
    saveError,
}: Props) => {
    if (isMobile) {
        return (
            <span className="portal-edit-toolbar__mobile-note">
                {t.portal.dashboard.edit.mobileNote(lang)}
            </span>
        )
    }
    if (!editMode) {
        return (
            <Button
                text={t.portal.dashboard.edit.customize(lang)}
                variant="secondary"
                size="small"
                onClick={onStart}
            />
        )
    }
    return (
        <div className="portal-edit-toolbar">
            {saveError && (
                <span className="portal-edit-toolbar__error">
                    {t.portal.dashboard.edit.saveFailed(lang)}
                </span>
            )}
            <Button
                text={t.portal.dashboard.edit.cancel(lang)}
                variant="secondary"
                size="small"
                onClick={onCancel}
            />
            <Button
                text={t.portal.dashboard.edit.save(lang)}
                size="small"
                isDisabled={!isDirty}
                onClick={onSave}
            />
        </div>
    )
}
